import React from 'react';

import { useTheme } from '@mui/material';

export const AnnotateOverlay: React.FC = () => {
  const { palette } = useTheme();

  return (
    <div
      style={{
        background: palette.primary.dark,
        width: '100%',
        height: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        opacity: 0.8,
        zIndex: 2,
      }}
    />
  );
};
